module.exports = {
    yousician: 'https://yousician.com',
    songsLibrary: 'https://yousician.com/songs',
    blog: 'https://yousician.com/blog',
    forums: 'https://yousician.com/forum/index.php',
    support: 'https://yousician.zendesk.com/hc/en-us',
    zendeskAccess: 'https://yousician.zendesk.com/access/jwt',
    supportNew: 'https://yousician.zendesk.com/hc/en-us/requests/new',
    privacyNotice: 'https://yousician.com/privacy-notice',
    ccpaNotice: 'https://yousician.com/ccpa-notice',
    terms: 'https://yousician.com/terms-of-service',
    familyTerms: 'https://yousician.com/yousician-family-plan-terms-of-service',
    yousicianMainVideo:
        'https://www.youtube.com/embed/1boTOjVPP90?feature=oembed',
    press: 'https://yousician.com/press',
    itunesSubscription: 'https://apps.apple.com/account/subscriptions',
    itunesSubscriptionIOS: 'itms-apps://apps.apple.com/account/subscriptions',
    googleplaySubscription:
        'https://play.google.com/store/account/subscriptions',
    microsoftExcel:
        'https://support.office.com/en-us/article/text-import-wizard-c5b02af6-fda1-4440-899f-f78bafe41857',
    appleNumbers: 'https://support.apple.com/kb/PH26780',
    app: {
        apple: 'https://itunes.apple.com/us/app/yousician/id959883039',
        google:
            'https://play.google.com/store/apps/details?id=com.yousician.yousician',
    },
    help: {
        gifting: 'https://yousician.zendesk.com/hc/en-us/articles/360000638338',
        giftingRedeem:
            'https://yousician.zendesk.com/hc/en-us/articles/360000676257-How-to-redeem-a-gift-card',
    },
    gifting: {
        redeem: 'https://yousician.com/gift/redeem',
    },
    universalLink: 'https://open.yousician.com',
    appleManageSubscription: 'https://support.apple.com/en-us/HT202039',
    zendeskWidget:
        'https://static.zdassets.com/ekr/snippet.js?key=db714727-6224-48b7-b1eb-10b5db8a677d',
};
